module.exports = __webpack_public_path__ + "static/img/404.64add7b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.gif
// module id = 1377
// module chunks = 1